const moneyFormat = document.getElementById('cart-drawer').getAttribute('data-money-format');
const cartDrawer = document.querySelector('#cart-drawer');
const cartDrawerBody = document.querySelector('.cart-drawer__body');
const cartRecommendations = document.querySelector('#cart-recommendations');
const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
const cartDrawerClose = document.querySelectorAll('#close-cart');
const body = document.body;

function updateNavCartCount(count) {
    const navBasket = document.querySelector('#nav-bar__nav-basket');
    if (!navBasket) return;

    const label = `Open cart, ${count} item${count === 1 ? '' : 's'}`;
    navBasket.setAttribute('aria-label', label);

    const countLabel = navBasket.querySelector('span');
    if (countLabel) {
        countLabel.textContent = `Cart (${count})`;
    }
}

function refreshNavCartCount() {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            updateNavCartCount(cart.item_count);
        })
        .catch((e) => {
            console.error('Unable to refresh nav cart count', e);
        });
}

window.updateNavCartCount = updateNavCartCount;
window.refreshNavCartCount = refreshNavCartCount;

function formatMoney(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

// This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append.
async function refreshCartDrawer() {
    fetch('/?view=cart-drawer')
        .then(function (response) {
            return response.text();
        })
        .then(function (cartData) {
            let tempElement = document.createElement('div');

            tempElement.innerHTML = cartData;

            let fetchedDrawerBody = tempElement.querySelector('.cart-drawer__body');
            if (fetchedDrawerBody && cartDrawerBody) {
                cartDrawerBody.innerHTML = fetchedDrawerBody.innerHTML;
            }

            refreshNavCartCount();

            tempElement.remove();
        })
        .catch(e => {
            console.error('Unable to fetch cart drawer', e);
        });
}

async function toggleCartDrawer(isOpen) {
    if (isOpen) {
        setTimeout(() => {
            refreshCartDrawer();
            cartDrawer.style.transform = 'translateX(0)';
            cartDrawerOverlay.style.display = 'block';
            body.classList.add('cart-drawer-open');
            cartDrawer.setAttribute("aria-hidden", "false");          
            cartDrawerClose[0].focus();
        }, 300);
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart-drawer-refreshed'));
        }, 2000);
    } else {
        cartDrawer.style.transform = `translateX(${cartDrawer.offsetWidth}px)`;
        cartDrawerOverlay.style.display = 'none';
        body.classList.remove('cart-drawer-open');
        cartDrawer.setAttribute("aria-hidden", "true");
    }
}

const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
toggleCartDrawerButtons.forEach((button) => {
    button.addEventListener('click', () => toggleCartDrawer(true));
});

const elementsToTriggerCartDrawer = '.product-form__submit';
const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
elementsToTrigger.forEach((element) => {
    element.addEventListener('click', () => {
        refreshCartDrawer();
        toggleCartDrawer(true);
    });
});

// Function for close the cart drawer
const closeCart = () => {
    cartDrawerClose[0].blur();
    cartDrawer.style.transform = 'translateX(100%)';
    cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
    cartDrawer.setAttribute("aria-hidden", "true");
};

cartDrawerClose.forEach((button) => button.addEventListener('click', closeCart));
cartDrawerOverlay.addEventListener('click', closeCart);

// Hotkey to close the cart
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeCart();
    toggleCartDrawerButtons[0].focus();
  }
});


// This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function

cartDrawerBody.addEventListener('click', function (e) {
    if (e.target.classList.contains('cart-drawer-quantity__minus')) {
        const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
        const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
        const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
        cartDrawerQuantityVal.value = quantity;
        if (quantity >= 1) {
            updateCart(itemId, quantity, 'updateItemQty');
        } else {
            cartDrawerQuantityVal.value = 1;
        }
    }
    if (e.target.classList.contains('cart-drawer-quantity__plus')) {
        const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
        const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
        const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
        cartDrawerQuantityVal.value = quantity;
        updateCart(itemId, quantity, 'updateItemQty');
    }
    if (e.target.classList.contains('cart-drawer__item-delete')) {
        const itemId = e.target.getAttribute('data-item-id');
        updateCart(itemId, 0, 'removeItem')
    }
});

// this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
async function updateCart(itemId, quantity, type) {
    try {
        // Fetch the current cart
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const item = cart.items.find((item) => (item.key == itemId));
        // Check if the item is already at the desired quantity for update and return if true
        if (type === 'updateItemQty' && item.quantity === quantity) return;

        // Make a request to update or delete the item in the cart
        let updatedRes;
        if (type === 'updateItemQty') {
            updatedRes = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: itemId,
                    quantity: quantity
                })
            });
        } else if (type === 'removeItem') {
            updatedRes = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: itemId,
                    quantity: quantity
                })
            });
        }
        const updatedCart = await updatedRes.json();
        updateNavCartCount(updatedCart.item_count);

        if (type === 'updateItemQty') {

            const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
            cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);

            refreshCartDrawer();

        } else if (type === 'removeItem') {
            if (cart.items.length === 0) {
                cartDrawer.style.transform = 'translateX(100%)';
                document.querySelector('.cart-drawer-overlay').style.display = 'none';
                body.classList.remove('cart-drawer-open');
                document.querySelector('#cart-drawer__form').remove();
                const emptyState = document.createElement('div');
                emptyState.innerHTML = `
              <div class="cart-drawer__empty text-center py-[20px]">
                <p class="cart-drawer__empty-text"> Your Basket is empty </p>
                <span> Add your favorite items to your cart.</span>
                <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
              </div>`;
                document.querySelector('.cart-drawer .cart-drawer__body').appendChild(emptyState);
            } else {
                const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');

                removeItem.remove();
                await refreshCartDrawer();
            }
        }
    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

function getCartRecommendations() {
    const cartRecommendationsSection = document.querySelector('#cart-recommendations');
    if (!cartRecommendationsSection || !cartRecommendationsSection.dataset.url) return;
    const url = cartRecommendationsSection.dataset.url;

    if (!url || !cartRecommendationsSection) return;

    fetch(url)
        .then((response) => response.text())
        .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.cart-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                cartRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
            if (window.innerWidth < 990) {
                window.initCoddleProgressBar('cart-recommendations');
                cartDrawerBody.scrollTop = 0;
            }
            window.initCoddleVariantSwatches();
        })
        .catch((e) => {
            console.error('Unable to fetch cart recommendations', e);
        });
}

document.addEventListener('cart-drawer-refreshed', () => {
    getCartRecommendations();
});

document.addEventListener('DOMContentLoaded', () => {
    getCartRecommendations();
});